import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { GithubRepoUpdateInput, GithubRepoUpdatePayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = GithubRepoUpdateInput;
type TData = GithubRepoUpdatePayload;

export const useGithubRepoUpdate = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation githubRepoUpdate($input: GithubRepoUpdateInput!) {
      githubRepoUpdate(input: $input) {
        success
        errors
        errorCode
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
